export default {
  pages: {
    tour: {
      tabsLabel: "Tour details",
      gallery: {
        label: "Photo gallery",
        position: "Photo {{n}} of {{total}}",
        expand: "Enlarge",
        dialog: "Full-screen photos",
      },
    },
    legalNav: "Other policies",
    cart: {
      summary: "Booking summary",
    },
    paymentReturn: {
      reservation: "Booking",
    },
    notFound: {
      seoTitle: 'Page Not Found',
    },
    category: {
      notFoundTitle: 'Category not found',
      subtitles: {
        escunas:
          'Sail the crystal-clear waters of Paraty aboard traditional and luxury schooners. Shared or private tours, with stops at idyllic beaches.',
        privadas:
          'Complete exclusivity for your group. Choose the route and the pace, and enjoy the beaches of Paraty away from the crowds, aboard comfortable speedboats.',
        compartilhadas:
          'Group adventures on the waters of Paraty. Shared speedboat tours at affordable prices, full of unforgettable experiences.',
        jeep:
          'Explore the Atlantic Forest, waterfalls, cachaça distilleries and the Estrada Real of Paraty on thrilling 4x4 jeep tours.',
        bolivia:
          "Discover the largest salt flat in the world! Unforgettable expeditions across the Bolivian Altiplano — Salar de Uyuni, colorful lagoons, geysers, volcanoes and surreal landscapes.",
      },
    },
    about: {
      title: 'About Us',
      whoTitle: 'Who we are',
      whoText:
        'AQUAMARINA TOURS offers tour experiences in Paraty, focused on sea routes, nature, beaches, islands and the landscapes of the Costa Verde. Our operation pairs every tour with careful attention to the itinerary, comfort and safety throughout the experience.',
      whereTitle: 'Where we operate',
      whereText:
        'We operate in Paraty and the surrounding region, including bay routes, beaches, snorkeling spots, trails and tour experiences by boat and 4x4 vehicle.',
      proposalTitle: 'What we offer',
      proposalText1:
        'At AQUAMARINA TOURS, our goal is to offer itineraries that connect the sea, the landscapes and the local culture, focused on authentic, well-organized experiences for visitors, groups and families.',
      proposalText2:
        'For specific information about each tour, including duration, meeting point, conditions and availability, see the page of the tour you are interested in or contact us directly.',
    },
    contact: {
      title: 'Contact',
      talkTitle: 'Get in touch',
      whatsapp: 'WhatsApp',
      phone: 'Phone',
      email: 'Email',
      location: 'Location',
      locationValue: 'Paraty, RJ — Brazil',
      howTitle: 'How to book',
      howText:
        'To book or check availability, contact us on WhatsApp or by phone, or use the form in the contact section of the site. Let us know your preferred date, the number of people and the tour you are interested in.',
      hoursText:
        'Customer service hours: every day, from 8:30 a.m. to 10 p.m. Outside these hours, your message will be answered as soon as our team is available.',
    },
    legal: {
      privacy: {
        heading: 'Privacy Policy',
        body: [
          'AQUAMARINA TOURS collects and uses data solely for customer service, contact, booking and delivery of the requested service.',
          'Data may include name, contact details, booking information and messages sent through forms, WhatsApp or other communication channels.',
          'The site may use external analytics, hosting and contact tools, depending on the technology actually in use. Data will not be shared with third parties other than the providers required to operate the service.',
          'Users may request clarification, correction or deletion of their data, in accordance with applicable law, by email at paraty.sirenatours@gmail.com or on WhatsApp at +55 11 95245-1307.',
        ],
      },
      cookies: {
        heading: 'Cookie Policy',
        body: [
          'The site currently uses only the technologies required to load the application, maintain navigation and provide the features requested by the user.',
          'At this time, AQUAMARINA TOURS has not set up Google Analytics, Google Tag Manager or advertising cookies on the site.',
          'If new analytics or advertising tools are installed, this policy will be updated and consent will be requested where required by applicable law.',
          'Users can also control or delete cookies through their own browser settings.',
        ],
      },
      terms: {
        heading: 'Terms & Conditions',
        seller: {
          title: 'Seller legal details',
          name: 'Full name',
          document: 'ID document',
          brand: 'Trade name',
          address: 'Service address',
          email: 'Email',
          whatsapp: 'WhatsApp',
        },
        body: [
          'These Terms and Conditions govern the purchase of tours on aquamarinatours.art. Sales are made by {{sellerName}}, ID document no. {{sellerDocument}}, under the trade name AQUAMARINA TOURS, serving customers in Paraty, RJ, Brazil.',
          'By making a booking or a payment on the website, the customer confirms having read and accepted these terms, the Booking Policy, the Cancellation Policy and the Privacy Policy.',
          'The website sells bookings for tours in and around Paraty (schooners, speedboats, jeep tours and other experiences). Tours are run by the boats, vehicles and guides of local operators; AQUAMARINA TOURS is responsible for the sale, the booking and customer service before and after the tour.',
          'Prices are shown in Brazilian reais (R$), per person or for the whole boat or group, as stated on each tour. Prices for children and babies, and what is and is not included, are listed on each tour page. The total, the deposit and the balance are shown before payment.',
          'For tours booked online, the customer pays a deposit now (the percentage is shown in the summary before payment) by Pix or credit card, and the balance, if any, on the day of the tour. Online payments are processed by secure payment platforms such as Mercado Pago; card details are entered in the platform’s form and are not stored by AQUAMARINA TOURS.',
          'Some tours, such as private ones, are booked through a WhatsApp quote: nothing is charged on the website, and the price and conditions are agreed in writing before payment.',
          'The booking is confirmed once the deposit payment is approved. The customer then receives the booking details and tour instructions by email. A booking whose Pix is not paid within the time shown at payment is cancelled automatically, at no cost.',
          'In exceptional cases, such as a seat taken by another customer at the same moment, the booking may be put under review. If it cannot be confirmed, the customer is notified and receives a full refund of the amount paid.',
          'Cancellation by the customer 7 days or more before the tour: 100% refund of the amount paid. Between 7 days and 48 hours before: 80% refund. Less than 48 hours before, or no-show: no refund. Refunds are made through the same payment method used. See the Cancellation Policy for details.',
          'The operator may change, postpone or cancel the tour due to weather, safety or orders from the authorities (such as the Brazilian Navy). In those cases the customer chooses between rescheduling at no cost or a 100% refund of the amount paid.',
          'The customer must provide correct details (name, email, phone and document), arrive at the meeting point on time, show an ID document when asked and follow the instructions of the crew and guides. Minors must be accompanied by a responsible adult.',
          'Personal data is used only for the booking, the payment, customer service and sending the confirmation, as described in the Privacy Policy and under Brazil’s data protection law (LGPD).',
          'Questions, changes and complaints: email {{email}} or WhatsApp {{phone}}.',
          'These terms are governed by Brazilian law, in particular the Consumer Protection Code. Any dispute will be settled in the courts of the consumer’s place of residence.',
          'AQUAMARINA TOURS may update these terms; the version published at the time of purchase always applies.',
        ],
        updated: 'Last updated: October 27, 2026.',
        acceptNote: 'By paying, you accept the <terms>Terms & Conditions</terms> and the <cancel>Cancellation Policy</cancel>.',
      },
      reservations: {
        heading: 'Booking Policy',
        body: [
          'Bookings can be confirmed by contacting AQUAMARINA TOURS via WhatsApp, phone or the channel indicated on the site.',
          'Before final confirmation, availability, date, itinerary, meeting point and the specific conditions of the tour must be verified.',
          'A booking is confirmed when the customer pays a deposit of 20% of the total tour price.',
          'Payment can be made via PIX or credit card, including Visa and Mastercard, as instructed by our customer service team.',
          'Once the deposit is confirmed, our team will send the booking and tour details through the customer service channel used.',
        ],
      },
      cancellations: {
        heading: 'Cancellation Policy',
        body: [
          'Cancellations must be communicated through the method agreed with AQUAMARINA TOURS.',
          'Cancellation 7 days or more in advance: 100% of the amount paid is refunded.',
          'Cancellation between 7 days and 48 hours before the tour: 20% of the amount paid is withheld and 80% is refunded.',
          'Cancellation less than 48 hours before the tour, or no-show: no refund.',
          'If the company cancels the tour for safety, weather or operational reasons, the customer may reschedule it or receive a 100% refund of the amount paid.',
          'This policy follows the Brazilian Consumer Protection Code (Código de Defesa do Consumidor) and applicable Brazilian law.',
        ],
      },
    },
  },
};
